const isStorageEmptyLong = localStorage.getItem("cuffCoordinatesLongitude");
if (isStorageEmptyLong !== '') {
    localStorage.setItem("cuffCoordinatesLongitude", '');
    localStorage.setItem("cuffCoordinatesLatitude", '');
}


$('#latitude').val(localStorage.getItem("cuffCoordinatesLatitude"));
$('#longtitude').val(localStorage.getItem("cuffCoordinatesLongitude"));
$('#latitude, #longtitude, #individual_engraving').attr('disabled', 'disabled');

/* started Toggle Map */
$('body').on('click', '.more-btn', function (e) {
    e.preventDefault();
    $('#tabs-1').show();
    var $this = $(this);
    setTimeout(function () {
        $this.removeClass('more-btn').addClass('remove-btn');
        $this.html(theme.strings.engravingMapToggleHide);
    });
    $('#latitude, #longtitude, #individual_engraving').removeAttr('disabled');
    $('.input-container-switch').html('<div class="line-item-property__field maps-latitude"><input id="latitude" maxlength="14" type="text" name="properties[Latitude]" value="' + localStorage.getItem("cuffCoordinatesLatitude") + '"></div><div class="line-item-property__field maps-longitude"><input id="longtitude" maxlength="14" type="text" name="properties[Longitude]" value="' + localStorage.getItem("cuffCoordinatesLongitude") + '"></div>');
    customEngraving();
});

$('body').on('click', '.remove-btn', function (e) {
    e.preventDefault();
    $('#tabs-1').hide();
    var $this = $(this);
    setTimeout(function () {
        $this.removeClass('remove-btn').addClass('more-btn');
        $this.html(theme.strings.engravingMapToggleText);
    });
    $('#latitude, #longtitude, #individual_engraving').attr('disabled', 'disabled');
    customEngraving();
});
/* Ended Toggle Map */

/*  TO MAKE THE MAP APPEAR YOU MUST
    ADD YOUR ACCESS TOKEN FROM
    https://account.mapbox.com */

mapboxgl.accessToken = 'pk.eyJ1Ijoic2hvcGxhYiIsImEiOiJja2duczZtNXIzOGN4MnJzMXloZGRmMHo4In0.BFO1eT0kDv_Dc7PObyP7iQ';
var map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/mapbox/streets-v11',
    center: [115.1383, -8.3692],
    zoom: 13
});

// Add geolocate control to the map.

const geolocate = new mapboxgl.GeolocateControl({
    positionOptions: {
        enableHighAccuracy: true
    },
    trackUserLocation: true
});

map.addControl(geolocate);

map.on('load', function () {
    map.resize();
    $("#map").css("pointer-events", "none");
});

geolocate.on('geolocate', function () {
    //Get the updated user location, this returns a javascript object.
    var userlocation = geolocate._lastKnownPosition;

    var lat = userlocation.coords.latitude;
    var lng = userlocation.coords.longitude;
    updateCoordinateInputs(lat, lng);
});

function findLocation() {
    document.querySelector('.mapboxgl-ctrl-geocoder--input').id = 'mapbox-search';
    document.querySelector('.suggestions').id = 'suggestionsBox';
    geocoder.query(document.getElementById("mapbox-search").value);
    document.getElementById("suggestionsBox").style.display = 'none';
}

var checkbox = document.getElementById("map-lock-input");

checkbox.addEventListener('change', function () {
    if (this.checked) {
        $("#map").css("pointer-events", "auto");
    } else {
        $("#map").css("pointer-events", "none");
    }
});

var geocoder = new MapboxGeocoder({
    accessToken: mapboxgl.accessToken,
    mode: 'mapbox.places', // does not provide POI data
    mapboxgl: mapboxgl,
    placeholder: theme.strings.customCuffMapInputPlaceholder,
    flyTo: {
        duration: 0
    }

});
geocoder.on('result', function (ev) {
    var latString = ev.result.geometry.coordinates[1];
    var lngString = ev.result.geometry.coordinates[0];
    $('.mapboxgl-ctrl-geocoder--input').blur();

    var lat = JSON.stringify(latString);
    var lng = JSON.stringify(lngString);
    // console.log('on geocode result', lat, lng);
    updateCoordinateInputs(lat, lng);

});


map.on('click', function (e) {
    var lat = JSON.stringify(e.lngLat.lat);
    var lng = JSON.stringify(e.lngLat.lng);
    // console.log('on map click', lat, lng);
    if (geocoder.mapMarker) {
        geocoder.mapMarker.setLngLat(e.lngLat);
        updateCoordinateInputs(lat, lng);
    } else {
        var marker = new mapboxgl.Marker()
            .setLngLat(e.lngLat)
            .addTo(map);
        geocoder.mapMarker = marker;
        updateCoordinateInputs(lat, lng);
    }
});

/* Convert DD To DMS */
function _convertDDToDMS(coordinate) {
    var absolute = Math.abs(coordinate);
    var degrees = Math.floor(absolute);
    var minutesNotTruncated = (absolute - degrees) * 60;
    var minutes = Math.floor(minutesNotTruncated);
    var seconds = Math.round((minutesNotTruncated - minutes) * 60 * 100) / 100;
    if (coordinate < 0) degrees *= -1;
    return degrees + "°" + minutes + "'" + seconds.toFixed(2);
}

function convertDDToDMS(lat, lng) {
    lat = Number(String(lat).replace(/° \w/, ""));
    lng = Number(String(lng).replace(/° \w/, ""));
    var latitude = _convertDDToDMS(lat);
    // 115.1383° E
    var latitudeCardinal = lat > 0 ? "''N" : "''S";

    var longitude = _convertDDToDMS(lng);
    var longitudeCardinal = lng > 0 ? "''E" : "''W";

    return {
        latitude: latitude + latitudeCardinal,
        longtitude: longitude + longitudeCardinal
    };
}

/* Convert DMS To DD */
function _convertDMSToDD(degrees, minutes, seconds, direction) {
    let dd = Number(degrees) + Number(minutes) / 60 + Number(seconds) / 3600;

    if (direction == "S" || direction == "W") {
        dd = dd * -1;
    } // Don't do anything for N or E
    return dd.toFixed(4) + "° " + (direction);
}

function convertDMSToDD(lat, lng) {
    let latParts = lat.match(/(\d+)°(\d+)'(\d+\.?\d*)''(\w)/);
    let longParts = lng.match(/(\d+)°(\d+)'(\d+\.?\d*)''(\w)/);
    let latitude = _convertDMSToDD(latParts[1], latParts[2], latParts[3], latParts[4]);
    let longtitude = _convertDMSToDD(longParts[1], longParts[2], longParts[3], longParts[4]);
    return {
        latitude: latitude,
        longtitude: longtitude
    }
}

function updateCoordinateInputs(lat, lng) {

    if (lat > 0) {
        lat = parseFloat(lat).toFixed(4) + "° N";
    } else {
        lat = parseFloat(lat).toFixed(4) + "° S";
    }
    if (lng > 0) {
        lng = parseFloat(lng).toFixed(4) + "° E";
    } else {
        lng = parseFloat(lng).toFixed(4) + "° W";
    }

    localStorage.setItem("cuffCoordinatesLongitude", lng);
    localStorage.setItem("cuffCoordinatesLatitude", lat);

    if ($("#dmstoggler_change").is(":checked")) {
        let dms = convertDDToDMS(lat, lng);
        lat = dms.latitude;
        lng = dms.longtitude;
    }
    document.getElementById('latitude').value = lat;
    document.getElementById('longtitude').value = lng;
}

function localStorageGetLng() {
    let lng = localStorage.getItem("cuffCoordinatesLongitude");
    if ($("#dmstoggler_change").is(":checked")) {
        lng = convertDDToDMS(0, lng).longtitude;
    }
    return lng;
}

function localStorageGetLat() {
    let lat = localStorage.getItem("cuffCoordinatesLatitude");
    if ($("#dmstoggler_change").is(":checked")) {
        lat = convertDDToDMS(lat, 0).latitude;
    }
    return lat;
}

$("#dmstoggler").on('change', function (eventInfo) {
    let longInput = document.getElementById("longtitude");
    let latInput = document.getElementById("latitude");

    if (eventInfo.target.checked) {
        $('#custom-engraving').focus();
        $('#custom-engraving').append('&nbsp;'+latInput.value + ' ' + longInput.value);
        $('.dmsslider').html('Einfügen');
        customEngraving();
    } else {
        $('#custom-engraving').focus();
        $('#custom-engraving').append('&nbsp;'+latInput.value + ' ' + longInput.value);
        $('.dmsslider').html('Einfügen');
        //$('.selected_individual_engraving').val('');
        //$('#custom-engraving').html('');
        customEngraving();
    }
});

$("#dmstoggler_change").on('change', function(eventInfo) {
    let longInput = document.getElementById("longtitude");
    let latInput = document.getElementById("latitude");
    if (eventInfo.target.checked) {
        // convert to DMS
        let dms = convertDDToDMS(latInput.value, longInput.value);
        latInput.value = dms.latitude;
        longInput.value = dms.longtitude;
        localStorage.setItem("cuffCoordinatesLongitude", dms.longtitude);
        localStorage.setItem("cuffCoordinatesLatitude", dms.latitude);
    } else {
        // convert back to decimal degrees
        let dd = convertDMSToDD(latInput.value, longInput.value);
        latInput.value = dd.latitude;
        longInput.value = dd.longtitude;
        localStorage.setItem("cuffCoordinatesLongitude", dd.longtitude);
        localStorage.setItem("cuffCoordinatesLatitude", dd.latitude);
    }
    $("#dmstoggler_state").html(eventInfo.target.checked ? "DMS" : "Decimal degrees");
});

map.addControl(new mapboxgl.NavigationControl());
document.getElementById('geocoder').appendChild(geocoder.onAdd(map));

$(".mapboxgl-ctrl-geocoder--input").on("click", function (event) {
    geocoder.clear();
    $(".mapboxgl-ctrl-geocoder--input").attr('placeholder', '');
    event.preventDefault();
    event.stopPropagation();
});


$('.mapboxgl-ctrl-geocoder--input').keypress(function (e) {
    if (e.which == 13) return false;
    //or...
    if (e.which == 13) e.preventDefault();
});

var customEngravingMessage = '';
// cache selectors
const $textInputForm = $('#custom-engraving');
const $counterSelector = $("#counter");
const $selectedEngravingSel = $('.selected_engraving');

initEngravingSwatcher();
initEmojiPicker();

// prevent copy paste
$('#custom-engraving').on("cut copy paste", function (e) {
    e.preventDefault();
});

$('body').on('focus', '#custom-engraving', function () {
    const $this = $(this);
    $this.data('before', $this.html());
}).on('blur keyup paste input', '#custom-engraving', function () {
    const $this = $(this);
    if ($this.data('before') !== $this.html()) {
        $this.data('before', $this.html());
        customEngraving();
    }
});

/* Image to HTML */
function pasteHtmlAtCaret(html, selectPastedContent) {
    var sel, range;
    if (window.getSelection) {
        // IE9 and non-IE
        sel = window.getSelection();
        if (sel.getRangeAt && sel.rangeCount) {
            range = sel.getRangeAt(0);
            range.deleteContents();

            var el = document.createElement("div");
            el.innerHTML = html;
            var frag = document.createDocumentFragment(),
                node, lastNode;
            while ((node = el.firstChild)) {
                lastNode = frag.appendChild(node);
            }
            var firstNode = frag.firstChild;
            range.insertNode(frag);

            // Preserve the selection
            if (lastNode) {
                range = range.cloneRange();
                range.setStartAfter(lastNode);
                if (selectPastedContent) {
                    range.setStartBefore(firstNode);
                } else {
                    range.collapse(true);
                }
                sel.removeAllRanges();
                sel.addRange(range);
            }
        }
    } else if ((sel = document.selection) && sel.type != "Control") {
        // IE < 9
        var originalRange = sel.createRange();
        originalRange.collapse(true);
        sel.createRange().pasteHTML(html);
        if (selectPastedContent) {
            range = sel.createRange();
            range.setEndPoint("StartToStart", originalRange);
            range.select();
        }
    }
}

function getCharacterOffsetWithin_final(range, node) {
    var treeWalker = document.createTreeWalker(
        node,
        NodeFilter.ELEMENT_NODE,
        function (node) {
            var nodeRange = document.createRange();
            nodeRange.selectNodeContents(node);
            return nodeRange.compareBoundaryPoints(Range.END_TO_END, range) < 1 ?
                NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
        },
        false
    );

    var charCount = 0,
        lastNodeLength = 0;

    if (range.startContainer.nodeType == 3) {
        charCount += range.startOffset;
    }

    while (treeWalker.nextNode()) {
        charCount += lastNodeLength;
        lastNodeLength = 0;

        if (range.startContainer != treeWalker.currentNode) {
            if (treeWalker.currentNode instanceof Text) {
                lastNodeLength += treeWalker.currentNode.length;
            } else if (treeWalker.currentNode instanceof HTMLBRElement ||
                treeWalker.currentNode instanceof HTMLImageElement) {
                lastNodeLength++;
            }
        }
    }

    return charCount + lastNodeLength;
}

var update = function () {
    var el = document.getElementById("custom-engraving");
    var range = window.getSelection().getRangeAt(0);
};
$('#custom-engraving').on("mouseup keyup", update);

//Namespace management idea from http://enterprisejquery.com/2010/10/how-good-c-habits-can-encourage-bad-javascript-habits-part-1/
(function( cursorManager ) {

    //From: http://www.w3.org/TR/html-markup/syntax.html#syntax-elements
    var voidNodeTags = ['AREA', 'BASE', 'BR', 'COL', 'EMBED', 'HR', 'IMG', 'INPUT', 'KEYGEN', 'LINK', 'MENUITEM', 'META', 'PARAM', 'SOURCE', 'TRACK', 'WBR', 'BASEFONT', 'BGSOUND', 'FRAME', 'ISINDEX'];

    //From: https://stackoverflow.com/questions/237104/array-containsobj-in-javascript
    Array.prototype.contains = function(obj) {
        var i = this.length;
        while (i--) {
            if (this[i] === obj) {
                return true;
            }
        }
        return false;
    }

    //Basic idea from: https://stackoverflow.com/questions/19790442/test-if-an-element-can-contain-text
    function canContainText(node) {
        if(node.nodeType == 1) { //is an element node
            return !voidNodeTags.contains(node.nodeName);
        } else { //is not an element node
            return false;
        }
    };

    function getLastChildElement(el){
        var lc = el.lastChild;
        while(lc && lc.nodeType != 1) {
            if(lc.previousSibling)
                lc = lc.previousSibling;
            else
                break;
        }
        return lc;
    }

    //Based on Nico Burns's answer
    cursorManager.setEndOfContenteditable = function(contentEditableElement)
    {

        while(getLastChildElement(contentEditableElement) &&
              canContainText(getLastChildElement(contentEditableElement))) {
            contentEditableElement = getLastChildElement(contentEditableElement);
        }

        var range,selection;
        if(document.createRange)//Firefox, Chrome, Opera, Safari, IE 9+
        {    
            range = document.createRange();//Create a range (a range is a like the selection but invisible)
            range.selectNodeContents(contentEditableElement);//Select the entire contents of the element with the range
            range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
            selection = window.getSelection();//get the selection object (allows you to change selection)
            if(selection.focusOffset == 0) {
                selection.removeAllRanges();//remove any selections already made
            }
            selection.addRange(range);//make the range you have just created the visible selection
        }
        else if(document.selection)//IE 8 and lower
        { 
            range = document.body.createTextRange();//Create a range (a range is a like the selection but invisible)
            range.moveToElementText(contentEditableElement);//Select the entire contents of the element with the range
            range.collapse(false);//collapse the range to the end point. false means collapse to end rather than the start
            range.select();//Select the range (make it the visible selection
        }
    }

}( window.cursorManager = window.cursorManager || {}));
/* Custom Image Picker */
function initEmojiPicker() {
    $('.icon_image').on('click', function (ev) {
        var img_add_str = '&nbsp;'+ $(this).prop('outerHTML');
        $('#custom-engraving').focus();
        var editableDiv = document.getElementById("custom-engraving");
        cursorManager.setEndOfContenteditable(editableDiv);
        pasteHtmlAtCaret(img_add_str);
        customEngraving();
    });
}

function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

/* german vowels validate */
function regexCustomTextString(string) {
    return /^[0-9a-zA-ZäöÃ¤Ã¶'üÄÖÜÃ¼Ã„Ã–Ãœ _,;"()!#\&*\°\)\(:+=._-]{0,}$/g.test(string);
    //return /^[0-9a-zA-ZÃ¤Ã¶'Ã¼Ã„Ã–Ãœ _,;()!#\&*\°\)\(:+=._-]{0,}$/g.test(string);
    // return /^[0-9a-zA-Zäö'üÄÖÜ ,;"()!#\&*\°\)\(:+=.-]{0,}$/g.test(string);
    
}
/* Validate Enter key */
$("#custom-engraving").keypress(function (e) {
    return e.which != 13;
});

/* Custom Properties */
function cleanCustomString(full_emoji_string) {
    full_emoji_string = full_emoji_string.replace(/<br>/g, '');
    full_emoji_string = full_emoji_string.replace(/<br \/>/g, '');

    $(".icon_image").each(function (index) {
        var search_string = $(this).prop('outerHTML');
        search_string = escapeRegExp(search_string);
        var regex_emoji_replace = new RegExp(search_string, "g");
        full_emoji_string = full_emoji_string.replace(regex_emoji_replace, "1");
    });
    full_emoji_string = full_emoji_string.replace(/&nbsp;/g, ' ');
    full_emoji_string = full_emoji_string.trim();
    return full_emoji_string;
}

/* Icon to HTML */
function prepareCustomText(full_emoji_string, pretty_or_raw) {
    full_emoji_string = full_emoji_string.replace(/<br>/g, '');
    full_emoji_string = full_emoji_string.replace(/<br \/>/g, '');

    $(".icon_image").each(function (index) {
        var search_string = $(this).prop('outerHTML');
        search_string = escapeRegExp(search_string);
        var regex_emoji_replace = new RegExp(search_string, "g");
        if (pretty_or_raw == 'pretty') {
            full_emoji_string = full_emoji_string.replace(regex_emoji_replace, $(this).data('prettyicon'));
        } else {
            full_emoji_string = full_emoji_string.replace(regex_emoji_replace, $(this).data('iconcode'));
        }
    });
    full_emoji_string = full_emoji_string.replace(/&nbsp;/g, ' ');
    full_emoji_string = full_emoji_string.trim();
    full_emoji_string = full_emoji_string.toUpperCase();
    return full_emoji_string;
}

function customEngraving() {
    var full_emoji_string = $('#custom-engraving').html();
    full_emoji_string = cleanCustomString(full_emoji_string);

    var customTextValue = $("#custom-engraving").html();
    var formattedTextHTML = prepareCustomText(customTextValue, 'pretty');
    $('.selected_individual_engraving').val(formattedTextHTML);
    customTextCounter(full_emoji_string.length);
}


function initEngravingSwatcher() {
    const $engravingSelector = $('.image_swatcher-wrapper');
    $engravingSelector.on('click', function (ev) {
        const $this = $(this);
        $this.closest('.divWrap').find('.image_swatcher-wrapper').removeClass('selected');
        $selectedEngravingSel.html('');
        let cartLabelValue = $this.closest('.image_swatcher-wrapper').find('.engraving_swatcher').data("cartlabel");
        let cartInternalLabel = $this.closest('.image_swatcher-wrapper').find('.engraving_swatcher').data("internallabel");
        // console.log(cartLabelValue);
        $this.closest('.image_swatcher-wrapper').addClass('selected');
        $selectedEngravingSel.html('<input class="selected_item_engraving" name="properties[Engraving type]" type="hidden" data-internallabel="' + cartInternalLabel + '" value="' + cartLabelValue + '"></input>');
    });
}

/* Counter Function */
function customTextCounter(totalChars) {
    $counterSelector.html("<strong>" + totalChars + "/" + limitChar + "</strong>");
    // console.log(totalChars, limitChar);
    if (totalChars > limitChar) {
        $counterSelector.css("color", "#ff7777");
        $('#custom-engraving-error').show();
    } else {
        $counterSelector.css("color", "#111111");
        $('#custom-engraving-error').hide();
    }
}

/* Generate Unique ID*/ 
function customUniqID(idlength) {
    var charstoformid = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'.split('');
    if (!idlength) {
        idlength = Math.floor(Math.random() * charstoformid.length);
    }
    var cuniqid = '';
    for (var i = 0; i < idlength; i++) {
        cuniqid += charstoformid[Math.floor(Math.random() * charstoformid.length)];
    }
    return cuniqid;
}

function cleanCustomString(full_emoji_string) {
    full_emoji_string = full_emoji_string.replace(/<br>/g, '');
    full_emoji_string = full_emoji_string.replace(/&amp;/g, '&');
    full_emoji_string = full_emoji_string.replace(/&gt;/g, '>');
    full_emoji_string = full_emoji_string.replace(/&lt;/g, '<');
    full_emoji_string = full_emoji_string.replace(/<br \/>/g, '');

    $(".icon_image").each(function (index) {
        var search_string = $(this).prop('outerHTML');
        search_string = escapeRegExp(search_string);
        var regex_emoji_replace = new RegExp(search_string, "g");
        full_emoji_string = full_emoji_string.replace(regex_emoji_replace, "1");
    });
    full_emoji_string = full_emoji_string.replace(/&nbsp;/g, ' ');
    full_emoji_string = full_emoji_string.trim();
    return full_emoji_string;
}

$('.cd-popup').on('click', function(event) {
    if ($(event.target).is('.cd-popup-close') || $(event.target).is('.cd-popup')) {
        event.preventDefault();
        $(this).removeClass('is-visible');
    }
});
$(document).keyup(function(event) {
    if (event.which == '27') {
        $('.cd-popup').removeClass('is-visible');
    }
});
$('[data-confirm-no]').on('click', function(event) {
    event.preventDefault();
    $('#custom-engraving').focus();
    $('.cd-popup').removeClass('is-visible');
})

$('[data-confirm]').click(function (e) {
    e.preventDefault();
    var status = {
        loading: false
    };
    let $addToCart = $(this);
    if (status.loading) {
        return;
    }
    $addToCart.addClass('btn--loading');
    status.loading = true;
    var property_unique = customUniqID(10);
    var currentVariant = $(".product-single__variants").val();
    var selectedEngraving = $('.selected_engraving .selected_item_engraving').val();
    var selectedEngravingInternalLabel = $('.selected_engraving .selected_item_engraving').attr('data-internallabel');
    var customTextValue = $("#custom-engraving").html();
    var qtySelected = $('.product__quantity .js-qty__num').val();
    var errors = 0;
    var cleanCustomTextValue = cleanCustomString(customTextValue);


    if (cleanCustomTextValue.length > 40) {
        errors++;
    }

    if (cleanCustomTextValue.length == 0) {
        errors++;
    }
    //     console.log(regexCustomTextString(cleanCustomTextValue) );
    if (regexCustomTextString(cleanCustomTextValue) !== true) {
        errors++;
    }
    if (errors > 0) {
        $('#custom-engraving-error').fadeIn();
        status.loading = false;
        $addToCart.removeClass('btn--loading');
    } else if (errors == 0) {

        if(customTextValue) customTextValue = customTextValue.replace('&amp;', "&");
        var formattedText = prepareCustomText(customTextValue, 'raw');
        var formattedTextHTML = prepareCustomText(customTextValue, 'pretty');
        
        $.ajax({
            method: "POST",
            url: "/cart/add.js",
            dataType: 'json',
            data: {
                quantity: qtySelected,
                id: currentVariant,
                properties: {
                    '_UNIQUE_ID': property_unique,
                    'Gravurtyp': selectedEngraving,
                    'Hinweis': 'Individuelle Wunschgravur',
                    'Individuelle Gravur': formattedTextHTML,
                    '_AJAX_Individuellle_Gravur': customTextValue,
                    '_CUSTOM_ENGRAVING': formattedText,
                    '_CUSTOM_ENGRAVING_TYPE': selectedEngraving
                }
            },
            success: function (data) {
                status.loading = false;
                $addToCart.removeClass('btn--loading');
                $('body').trigger('added.ajaxProduct', $addToCart);
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: data
                    }
                }));
                $('.cd-popup').removeClass('is-visible');
            },
            error: function () {
                status.loading = false;
                $addToCart.removeClass('btn--loading');
                $('.cd-popup').removeClass('is-visible');
            }
        });

    }
});
/* Add to cart Engraving */
$(".add-to-cart-engrave").click(function (e) {
    e.preventDefault();
    
    var status = {
        loading: false
    };
    let $addToCart = $(this);
    if (status.loading) {
        return;
    }
    // $addToCart.addClass('btn--loading');
    // status.loading = true;
    var property_unique = customUniqID(10);
    var currentVariant = $(".product-single__variants").val();
    var selectedEngraving = $('.selected_engraving .selected_item_engraving').val();
    var selectedEngravingInternalLabel = $('.selected_engraving .selected_item_engraving').attr('data-internallabel');
    var customTextValue = $("#custom-engraving").html();
    var qtySelected = $('.product__quantity .js-qty__num').val();
    var errors = 0;
    var cleanCustomTextValue = cleanCustomString(customTextValue);


    if (cleanCustomTextValue.length > 40) {
        errors++;
    }

    if (cleanCustomTextValue.length == 0) {
        errors++;
    }
    //     console.log(regexCustomTextString(cleanCustomTextValue) );
    if (regexCustomTextString(cleanCustomTextValue) !== true) {
        errors++;
    }
    if (errors > 0) {
        $('#custom-engraving-error').fadeIn();
        status.loading = false;
        $addToCart.removeClass('btn--loading');
    } else if (errors == 0) {
        
        $('.content_output').html($("#custom-engraving").html());
        $('.cd-popup').addClass('is-visible');

        return false;
    /**        
        $.ajax({
            method: "POST",
            url: "/cart/add.js",
            dataType: 'json',
            data: {
                quantity: qtySelected,
                id: currentVariant,
                properties: {
                    '_UNIQUE_ID': property_unique,
                    'Gravurtyp': selectedEngraving,
                    'Hinweis': 'Individuelle Wunschgravur',
                    'Individuelle Gravur': customTextValue,
                    '_CUSTOM_ENGRAVING': formattedText,
                    '_CUSTOM_ENGRAVING_TYPE': selectedEngraving
                }
            },
            success: function (data) {
                status.loading = false;
                $addToCart.removeClass('btn--loading');
                $('body').trigger('added.ajaxProduct', $addToCart);
                alert("");
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: data
                    }
                }));
            },
            error: function () {
                status.loading = false;
                $addToCart.removeClass('btn--loading');
            }
        });
    **/

    }
});

$(".add-to-cart-coordinate").click(function (e) {
    e.preventDefault();
    let $addToCart = $(this);
    if (status.loading) {
        return;
    }
    $addToCart.addClass('btn--loading');
    status.loading = true;
    var property_unique = customUniqID(10);
    var currentVariant = $(".product-single__variants").val();
    var selectedEngraving = $('#tabs-1 .selected_item_engraving').val();
    var selectedEngravingInternalLabel = $('#tabs-1 .selected_item_engraving').data('internallabel');
    var customTextValue = $('#latitude').val() + ' ' + $('#longtitude').val();
    var qtySelected = $('.product__quantity .js-qty__num').val();
    var errors = 0;
    var cleanCustomTextValue = cleanCustomString(customTextValue);
    if ($('#latitude').val() == '') {
        errors++;
    }
    if ($('#longtitude').val() == '') {
        errors++;
    }
    if (errors > 0) {
        $('#latitude, #longtitude').css('border', '1px solid red');
        status.loading = false;
        $addToCart.removeClass('btn--loading');
    } else if (errors == 0) {
        $('#latitude, #longtitude').css('border', '1px solid #e3e3e3');

        $.ajax({
            method: "POST",
            url: "/cart/add.js",
            dataType: 'json',
            data: {
                quantity: qtySelected,
                id: currentVariant,
                properties: {
                    '_UNIQUE_ID': property_unique,
                    'Gravurtyp': selectedEngraving,
                    'Hinweis': 'Individuelle Wunschgravur',
                    'Individuelle Gravur': customTextValue,
                    '_CUSTOM_ENGRAVING': customTextValue,
                    '_CUSTOM_ENGRAVING_TYPE': selectedEngravingInternalLabel
                }
            },
            beforeSend: function () {

            },
            success: function (data) {
                status.loading = false;
                $addToCart.removeClass('btn--loading');
                $('body').trigger('added.ajaxProduct', $addToCart);
                document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                    detail: {
                        product: data
                    }
                }));
            },
            error: function () {
                status.loading = false;
                $addToCart.removeClass('btn--loading');
            }
        });

    }
});
/* Ended Add to cart Engraving */